import { render } from "./HeaderBody.vue?vue&type=template&id=9052de70&scoped=true"
import script from "./HeaderBody.vue?vue&type=script&lang=js"
export * from "./HeaderBody.vue?vue&type=script&lang=js"

import "./HeaderBody.vue?vue&type=style&index=0&id=9052de70&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9052de70"]])

export default __exports__